import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=d4dba134&"
import script from "./Licenses.vue?vue&type=script&lang=ts&"
export * from "./Licenses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports